export const BLOG_CONTINUE_MODE = {
  fromEmpty: 'from_empty',
  continue: 'continue',
  insertion: 'insertion',
};

export const prepareContinueModeForBackend = (mode) => {
  // `fromEmpty` is FE-only value, so we should not send it to the backend
  if (mode === BLOG_CONTINUE_MODE.fromEmpty) {
    return null;
  }

  return mode;
};

export const BLOG_FACTS_TYPE = {
  first: 'first',
  web: 'web',
  resource: 'resource',
};
